var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78599 15.1431C1.39314 15.1431 1.05683 15.0033 0.777065 14.7235C0.497303 14.4437 0.357422 14.1074 0.357422 13.7146V4.42885C0.357422 4.22647 0.425874 4.05683 0.562779 3.91992C0.699684 3.78302 0.869327 3.71456 1.07171 3.71456C1.27409 3.71456 1.44373 3.78302 1.58064 3.91992C1.71754 4.05683 1.78599 4.22647 1.78599 4.42885V13.7146H8.92885C9.13123 13.7146 9.30087 13.783 9.43778 13.9199C9.57468 14.0568 9.64314 14.2265 9.64314 14.4288C9.64314 14.6312 9.57468 14.8009 9.43778 14.9378C9.30087 15.0747 9.13123 15.1431 8.92885 15.1431H1.78599ZM4.64314 12.286C4.25028 12.286 3.91397 12.1461 3.63421 11.8664C3.35445 11.5866 3.21456 11.2503 3.21456 10.8574V2.28599C3.21456 1.89314 3.35445 1.55683 3.63421 1.27706C3.91397 0.997303 4.25028 0.857422 4.64314 0.857422H11.0717C11.4646 0.857422 11.8009 0.997303 12.0806 1.27706C12.3604 1.55683 12.5003 1.89314 12.5003 2.28599V10.8574C12.5003 11.2503 12.3604 11.5866 12.0806 11.8664C11.8009 12.1461 11.4646 12.286 11.0717 12.286H4.64314ZM4.64314 10.8574H11.0717V2.28599H4.64314V10.8574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.8568824d26fa65c2da49552603ef0743.svg";
export { ForwardRef as ReactComponent };